import { DatePipe, getCurrencySymbol } from "@angular/common";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { environment } from "src/environments/environment";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { TargetSpecificCustomerComponent } from "src/app/shared/components/dialog-box/target-specific-customer/target-specific-customer.component";
import {
  HtmlForEmailTemplatesDialogComponent,
  SmsPreviewDialogComponent,
  SmsPreviewIdDialogComponent,
  SuccessDialogComponent,
} from "src/app/shared/components/dialog-box";
import { OfferAttachEmailDialogComponent } from "../offer-template-shopify/offer-attach-email-dialog/offer-attach-email-dialog.component";
import { SegmentsModule } from "../../../segments/segments.module";
import e from "express";
import { LoyaltyExpiryConfiguration, WalletExpiryConfiguration } from "src/app/shared/models/model";
import { WalletExpiryConfigurationComponent } from "src/app/shared/components/wallet-expiry-configuration/wallet-expiry-configuration.component";

@Component({
  selector: "app-gift-code-creation",
  templateUrl: "./gift-code-creation.component.html",
  styleUrls: [
    "./gift-code-creation.component.css",
    "../offer-creation-simplified/offer-creation-simplified.component.css",
  ],
})
export class GiftCodeCreationComponent implements OnInit {
  @Input() showViewForCouponPool = false;
  @Input() giftCodeDetailsInput = null;
  @Input() lockEdit = false;
  @ViewChild("giftCodeWalletConfig")
  giftCodeWalletConfig: WalletExpiryConfigurationComponent;
  @ViewChild("profileLoyaltyConfig")
  profileLoyaltyConfig: WalletExpiryConfigurationComponent;
  validWidgets;
  isAdminPos = false;
  currencySymbol;
  revCurrency;
  previewmode = false;
  adminMode = false;
  managerAdmin = false;
  saveAndScheduleButtonLoading = false;
  offerTemplateName = "";
  isofferNameCheckLoading = false;
  offerNameCheckInitialised = false;
  submitClicked = false;
  customDescription = "";
  customAliasDescription = "";
  customTermsAndCondition = "";
  customAliasTermsAndCondition = "";
  rewardTimeToComplete = null;
  giftCodeType = "EWALLET";
  loyaltyPoints;
  codeLength;
  eWallet;
  giftCodeTargetAudience = "CUSTOMER_SEGMENTS";
  disableCustomerSegmentSelection;
  disableAllCustomerSelection;
  selectedSegments;
  customerCount = 0;
  NotAllowedCustomer = 0;
  totalCustomer = 0;
  InvalidCustomer = 0;
  customerSegmentList = [];
  customerTierList = [];
  customerList = [];
  employeeList = [];
  storeCreatedCustomList = [];
  otherCustomList = [];
  storeCreatedSegments = [];
  otherSegments = [];
  storeId;
  submitted: boolean = false;
  selectedCustomer;
  @ViewChild("customerSegmentsSelect") customerSegmentsSelect: any;
  templateDispatchForm;
  tempsegmentFilter = new FormControl("");
  expiryDate = new FormControl(Validators.required);
  channels = ["SMS", "Email", "WhatsApp"];
  selectedChannelList = [];
  channelConfigureStatus = false;
  selectedChannel;
  errorChannelSelect = "";
  attachEmailError = "";
  attachSmsError = "";
  attachWhatsappError = "";
  showSMSWarning = 2;
  offerPushNotificationErrorText = null;
  offerPushTitleAlias: string;
  offerPushNotificationBody: string;
  preemailLayoutId = null;
  preemailLayoutName;
  presmsrewardId;
  presmsrewadLayoutName;
  prewhatsappLayoutId;
  prewhatsappLayoutName;
  offerEmailSubject;
  offerEmailSubjectErrorText;
  offerPushNotificationSubject;
  validScreens;
  allcustomerObj = [
    { id: "ALL_CUSTOMERS", name: "My Customers" },
    { id: "LEADS", name: "All Leads" },
  ];
  currentTimeMin;
  segmentLength = false;
  ValidCustomerCount = 0;
  UnsubscribedCount = 0;
  smsNoOfCustomersZeroError = "";
  apiloading = false;
  selectedEmailTemplateId;
  prerewardId;
  otherEmailTemplateList;
  templateList = [];
  rewardTemplateList = [];
  offerDiscountTypeEmailTemplateList;
  loading;
  selectedEmailTemplateName;
  selectedTemplateTableType;
  preemailTableType;
  finalScreenHeight;
  finalScreenWidth;
  scrHeight;
  scrWidth;
  isNonDiscountTypeEmailPicked = false;
  isNonDiscountTypeSMSPicked = false;
  filter = {
    label: "",
  };
  filterWhatsApp = {
    label: "",
  };
  filterEmail = {
    label: "",
  };
  smsRewardTemplateList = [];
  selectedSmsOfferPart;
  smsResponse;
  selectedSmsTemporaryId = null;
  rewardSMSLayoutJson;
  customSmsTemplateList = [];
  whatsAppResponse;
  whatsAppTemplateList;
  mainRewardtemplate;
  selectedWhatsAppTemporaryId = null;
  rewardWhatsAppLayoutJson;
  prewhatsappLayoutData = null;
  giftCodeValidityType = "NO_OF_DAYS";
  emailResponse;
  smsTemplateList;
  timeout;
  sub: Subscription;
  offerNameDuplicate = false;
  queryparamofferId = null;
  adminCreated = {
    storeId: null,
    storeName: "ADMIN",
    qid: null,
    userName: this.tokenStorage.getUsernameFull(),
    userEmail: this.tokenStorage.getMerchantUserEmail(),
  };
  storeDataJSON = {};
  finalData;
  selectedCustomerDetails: any;
  startDateMinValue;
  ledgerList = [];
  selectedLedgerId;
  giftcodeAliasName = "";
  isAutoreserve = true;
  walletExpiryConfiguration: WalletExpiryConfiguration = {
    expiryType: "DEFAULT",
    duration: {
      value: 0,
      unit: "DAYS",
    },
    validityDate: "",
    defaultExpiry: true,
    noExpiry: false,
  };
  loyaltyExpiryConfig: LoyaltyExpiryConfiguration = {
          expiryType: "DEFAULT",
          duration: 0,
          timeFrame: "DAYS",
          validityDate: "",
          defaultExpiry: true
  };

  constructor(
    public dialog: MatDialog,
    private apiCall: ApiCallService,
    private snackBar: SnackbarCollection,
    private route: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private _WidgetConfigService: WidgetConfigService,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private date_format: getdateformatService,
    private datePipe: DatePipe
  ) {
    window["screen-name"] = "OFFER CREATE";
  }
  async getWidgets() {
    this.validWidgets = await this._WidgetConfigService.getWidget();
  }
  async ngOnInit() {
    this.templateDispatchForm = new FormGroup({
      dispatchcustomerSegments: new FormControl("", [Validators.required]),
      tempsegmentFilter: new FormControl(""),
    });
    this.queryparamofferId = this.route.snapshot.queryParams["id"]
      ? this.route.snapshot.queryParams["id"]
      : null;
    this.queryparamofferId = this.route.snapshot.paramMap.get("id")
      ? this.route.snapshot.paramMap.get("id")
      : this.queryparamofferId;
    if (this.route.snapshot.paramMap.get("id")) {
      this.previewmode = true;
      try {
        await this.getOfferDetails(this.route.snapshot.paramMap.get("id"));
      } catch (error) {
        console.error("Error getting offer details:", error);
      }
    } else {
      if (this.showViewForCouponPool && this.giftCodeDetailsInput) {
        this.processDetails(this.giftCodeDetailsInput);
      }
    }
    this.storeId =
      this.tokenStorage.getqId() === "null" ? null : this.tokenStorage.getqId();
    if (this.tokenStorage.getqId() != "null") {
      this.getParticularStoreJSON();
      this.isAdminPos = false;
    } else {
      this.isAdminPos = true;
    }
    this.getWidgets();
    this.revCurrency = sessionStorage.getItem("serviceCurrency");
    this.currencySymbol = getCurrencySymbol(this.revCurrency, "narrow");
    this.getCustomerSegmentsAndTiers();
    this.getScreenId();
    this.getTemplates(this.preemailLayoutId);
    this.getrewardemail(this.preemailLayoutId);
    this.getAllCustomSmsTemplates(this.presmsrewardId);
    this.getWhatsAppTemplate();
    this.getLedgerList();

    let currentDate = new Date();
    this.startDateMinValue = new Date(
      currentDate.toLocaleString("en-US", {
        timeZone: this.tokenStorage.getMerchantTimeZone(),
      })
    );
  }

  async getScreenId() {
    this.validScreens = await this._WidgetConfigService.getScreen();
    let index = this.validScreens?.findIndex((d) => d === this.getId("leads"));
    if (index === -1) {
      this.allcustomerObj = this.allcustomerObj.filter(
        (item) => item.id !== "LEADS"
      );
    }
  }

  getLedgerList() {
    this.apiCall.getLedgerList().subscribe(
      (response) => {
        this.ledgerList = response["body"].ledgerList;
        if (this.ledgerList.length > 0) {
          this.selectedLedgerId = !this.selectedLedgerId
            ? this.ledgerList[0].id
            : this.selectedLedgerId;
        }
      },
      (error) => {
        this.snackBar.openSnackBar("Error fetching ledger data", 2000);
      }
    );
  }

  getSelectedChannelList(channel) {
    let channelList = channel;
    if (channelList) {
      let list = JSON.parse(channelList);
      for (let k in list) {
        if (k === "email") {
          this.selectedChannelList.push(k);
          this.preemailLayoutId = list[k].id;
          if (list[k].subject) {
            this.offerEmailSubject = list[k].subject;
          }
        }
        if (k === "sms") {
          this.selectedChannelList.push(k);
          this.presmsrewardId = list[k].id;
        }
        if (k === "whatsapp") {
          this.selectedChannelList.push(k);
          this.prewhatsappLayoutId = list[k].id;
        }
        if (k === "appOnly") {
          this.selectedChannelList.push(k);
          this.prewhatsappLayoutId = list[k].id;
        }
        if (k === "pos") {
          this.selectedChannelList.push(k);
          this.prewhatsappLayoutId = list[k].id;
        }
        if (k === "pushNotification") {
          this.selectedChannelList.push(k);
          this.prewhatsappLayoutId = list[k].id;
          this.offerPushNotificationSubject = list[k].title;
          this.offerPushTitleAlias = list[k].aliasTitle;
          this.offerPushNotificationBody = list[k].body;
        }
      }
    }
    this.selectedChannel = this.selectedChannelList[0];
  }

  getParticularStoreJSON() {
    let data: any = {};
    this.apiCall.getSpecificStoreOffer().subscribe((response) => {
      // console.log(response)
      data.storeId = response["body"]["storeMetaInfo"].storeId;
      data.storeName = response["body"]["storeMetaInfo"].storeName;
      data.qid = response["body"]["storeMetaInfo"].qid;
      data.userName = this.tokenStorage.getUsernameFull();
      data.userEmail = this.tokenStorage.getMerchantUserEmail();
      this.storeDataJSON = data;
    });
  }

  async getOfferDetails(id): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiCall.getParticularGiftCodeDetails(id).subscribe(
        (response) => {
          if (response["message"] == "success") {
            let responsebody = response["body"];
            this.processDetails(responsebody);
          }
          resolve();
        },
        (err) => {
          this.snackBar.openSnackBar(
            this._i18nDynamicTranslate.transform(err.error.body, ["POS_PAGE"]),
            2000
          );
          reject(err);
        }
      );
    });
  }

  processDetails(responsebody) {
    this.offerTemplateName = responsebody["name"];
    if (responsebody["termsConditions"]) {
      this.customTermsAndCondition = this.convertToOriginalFormat(
        JSON.parse(responsebody["termsConditions"])
      );
    }
    if (responsebody["aliasTermsConditions"]) {
      this.customAliasTermsAndCondition = this.convertToOriginalFormat(
        JSON.parse(responsebody["aliasTermsConditions"])
      );
    }
    if (responsebody["description"]) {
      this.customDescription = this.convertToOriginalFormat(
        JSON.parse(responsebody["description"])
      );
    }
    if (responsebody["aliasDescription"]) {
      this.customAliasDescription = this.convertToOriginalFormat(
        JSON.parse(responsebody["aliasDescription"])
      );
    }
    if (responsebody["giftcodeAliasName"]) {
      this.giftcodeAliasName = responsebody["giftcodeAliasName"];
    }
    if (responsebody["autoreserve"]) {
      this.isAutoreserve = responsebody["autoreserve"];
    } 
    if(responsebody["loyaltyPointsExpiry"]) {
      this.loyaltyExpiryConfig = JSON.parse(
        responsebody["loyaltyPointsExpiry"]
      );
    }
    if(responsebody["programExpWalletConfig"]) {
      this.walletExpiryConfiguration = JSON.parse(
        responsebody["programExpWalletConfig"]
      );
    }
    if (responsebody["codeLength"]) {
      this.codeLength = responsebody["codeLength"];
    }
    const dateStr = responsebody["expiryDate"];
    const dateObj = new Date(dateStr.replace(" ", "T"));
    this.expiryDate.setValue(dateObj);
    this.giftCodeType = responsebody["rewardType"];
    if (this.giftCodeType === "LOYALTY_POINTS") {
      this.loyaltyPoints = responsebody["rewardValue"];
    } else {
      this.eWallet = responsebody["rewardValue"];
      this.selectedLedgerId = responsebody["ledgerId"];
    }

    console.log(this.giftCodeType);

    if (responsebody["customerIds"] != null) {
      this.giftCodeTargetAudience = "INDIVIDUAL_CUSTOMER";
      this.selectedCustomer = responsebody["customerIds"];
      this.apiCall
        .getCustomerDetails(this.selectedCustomer)
        .subscribe((response) => {
          this.selectedCustomerDetails = response["body"];
        });
    } else {
      this.giftCodeTargetAudience = "CUSTOMER_SEGMENTS";

      if (responsebody["segments"]) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          ...responsebody["segments"],
        ]);
      }
      if (responsebody["tiers"]) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          ...responsebody["tiers"],
        ]);
      }
      if (responsebody["customerListIds"]) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          ...responsebody["customerListIds"],
        ]);
      }
      if (responsebody["employeeListIds"]) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          ...responsebody["employeeListIds"],
        ]);
      }
      if (responsebody["allLead"] === true) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          "LEADS",
        ]);
      }
      if (responsebody["allCustomer"] === true) {
        this.templateDispatchForm.controls.dispatchcustomerSegments.setValue([
          ...this.templateDispatchForm.controls.dispatchcustomerSegments.value,
          "ALL_CUSTOMERS",
        ]);
      }
    }
    this.getSelectedChannelList(responsebody["channel"]);

          if(this.giftCodeDetailsInput?.checkNameOnLoad) {
            this.checkOfferName(false);
          }
  }

  onKeyOfferNameCheck(event: any) {
    if (this.offerTemplateName.length < 3) {
      this.offerNameCheckInitialised = false;
      return;
    }
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      $this.checkOfferName();
      // }
    }, 600);
  }

  checkOfferName(isIdSent?) {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    var str = this.offerTemplateName;
    if (!str.replace(/\s/g, "").length) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "Please enter valid gift code name",
          ["POS_PAGE"]
        ),
        2000
      );
      return;
    }

    this.isofferNameCheckLoading = true;
    this.offerNameCheckInitialised = true;
    this.offerNameDuplicate = false;
    let id = null;
    if (this.showViewForCouponPool && this.giftCodeDetailsInput?.id) {
      id = this.giftCodeDetailsInput.id;
    } else {
      id = this.route.snapshot.paramMap.get("id")
        ? this.route.snapshot.paramMap.get("clone")
          ? null
          : this.route.snapshot.paramMap.get("id")
        : null;
    }

    //dont send id explicitly
    if (isIdSent == false) {
      id = null;
    }

    this.sub = this.apiCall
      .GiftCodeNameValidation(this.offerTemplateName, id)
      .subscribe((response) => {
        this.isofferNameCheckLoading = false;
        if (response["message"] == "success" && response["body"] == "true") {
          this.offerNameDuplicate = true;
        } else {
          this.offerNameDuplicate = false;
        }
      });
  }

  getOnlySegments(data) {
    const temp = [...data]; // Create a shallow copy of the array
    let index1 = temp.indexOf("LEADS");
    let index2 = temp.indexOf("ALL_CUSTOMERS");

    if (index1 !== -1) {
      temp.splice(index1, 1);
    }
    // Recalculate index2 after modifying the array
    index2 = temp.indexOf("ALL_CUSTOMERS");
    if (index2 !== -1) {
      temp.splice(index2, 1);
    }

    return temp;
  }

  toUTC(time, timezone) {
    return this.datePipe.transform(time, "yyyy-MM-dd HH:mm:ss");
  }

  sendGiftCode() {
    this.submitClicked = true;
    const validationError = this.validateAllRequiredFields();
    if(this.giftCodeType === "LOYALTY_POINTS") {
      this.loyaltyExpiryConfig = this.profileLoyaltyConfig.getExpirationData();
    }
    if(this.giftCodeType === "EWALLET") {
      this.walletExpiryConfiguration = this.giftCodeWalletConfig.getExpirationData();
    }

    if (validationError || (!this.walletExpiryConfiguration && this.giftCodeType === "EWALLET") || (!this.loyaltyExpiryConfig  && this.giftCodeType === "LOYALTY_POINTS")) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "Please fill all the required fields",
          ["POS_PAGE"]
        ),
        2000
      );
      return;
    }
    if (this.expiryDate.value) {
      let date = new Date(this.expiryDate.value);
      date.setHours(23, 59, 59, 999);
      this.expiryDate.setValue(date);
    }
    if(this.loyaltyExpiryConfig){
      this.loyaltyExpiryConfig.validityDate = this.loyaltyExpiryConfig.validityDate?.replace("T", " ");
    } 

    this.finalData = {
      name: this.offerTemplateName,
      merchantId: this.tokenStorage.getMerchantId(),
      channel: JSON.stringify(this.getCommunication()),
      rewardType: this.giftCodeType,
      rewardValue:
        this.giftCodeType === "LOYALTY_POINTS"
          ? this.loyaltyPoints
          : this.eWallet,
      expiryDate: this.toUTC(
        this.datePipe.transform(this.expiryDate.value, "yyyy-MM-dd HH:mm:ss"),
        "UTC"
      ),
      allCustomer: this.templateDispatchForm.controls.dispatchcustomerSegments[
        "value"
      ].includes("ALL_CUSTOMERS")
        ? true
        : false,
      allLead: this.templateDispatchForm.controls.dispatchcustomerSegments[
        "value"
      ].includes("LEADS")
        ? true
        : false,
      createdBy:
        this.tokenStorage.getqId() === "null"
          ? this.adminCreated
          : this.storeDataJSON,
      adminCreated: this.tokenStorage.getqId() === "null" ? true : false,
      targetAudience: this.giftCodeTargetAudience,
      codeLength: parseInt(this.codeLength),
      autoreserve: this.isAutoreserve,
      programExpWalletConfig: this.giftCodeType === "EWALLET" ? JSON.stringify(this.walletExpiryConfiguration) : null,
      loyaltyPointsExpiry: this.giftCodeType === "LOYALTY_POINTS" ? JSON.stringify(this.loyaltyExpiryConfig) : null,
    };
    if (this.giftcodeAliasName.length > 0) {
      this.finalData.giftcodeAliasName = this.giftcodeAliasName;
    }
    if (this.giftCodeType == "EWALLET") {
      this.finalData.ledgerId = this.selectedLedgerId;
    }
    if (this.customTermsAndCondition.trim()) {
      this.finalData.termsConditions = JSON.stringify(
        this.updateBulletArray(this.customTermsAndCondition)
      );
    }
    if (this.customAliasTermsAndCondition.trim()) {
      this.finalData.aliasTermsConditions = JSON.stringify(
        this.updateBulletArray(this.customAliasTermsAndCondition)
      );
    }

    if (this.customDescription.trim()) {
      this.finalData.description = JSON.stringify(
        this.updateBulletArray(this.customDescription)
      );
    }
    if (this.customAliasDescription.trim()) {
      this.finalData.aliasDescription = JSON.stringify(
        this.updateBulletArray(this.customAliasDescription)
      );
    }
    if (this.giftCodeTargetAudience == "INDIVIDUAL_CUSTOMER") {
      if (!this.finalData.hasOwnProperty("customerListIds")) {
        this.finalData["customerIds"] = [];
      }
      this.finalData["customerIds"].push(
        this.selectedCustomerDetails["merchantCustomerId"]
      );
    }

    if (this.giftCodeTargetAudience == "CUSTOMER_SEGMENTS") {
      var isCustSegmented = true;
      const customerSegmentsValue =
        this.templateDispatchForm.controls.dispatchcustomerSegments["value"] ||
        [];
      const hasNumber = customerSegmentsValue.some(
        (item) => typeof item === "number"
      );
      if (customerSegmentsValue.includes("ALL_CUSTOMERS")) {
        isCustSegmented = false;
      }

      if (!customerSegmentsValue.includes("ALL_CUSTOMERS") && hasNumber) {
        isCustSegmented = true;
      }

      if (!hasNumber) {
        isCustSegmented = false;
      }

      this.finalData.allCustomer = customerSegmentsValue.includes(
        "ALL_CUSTOMERS"
      )
        ? true
        : false;
      this.finalData.allLead = customerSegmentsValue.includes("LEADS")
        ? true
        : false;

      if (
        customerSegmentsValue &&
        customerSegmentsValue.length > 0 &&
        isCustSegmented
      ) {
        this.finalData.segmented = true;
        this.finalData.segments = [];
        this.getOnlySegments(
          this.templateDispatchForm.controls.dispatchcustomerSegments.value
        ).forEach((selectedSegment) => {
          let req = [
            ...this.customerSegmentList,
            ...this.customerTierList,
            ...this.customerList,
            ...this.employeeList,
          ].find((segment) => selectedSegment === segment.id);
          if (req.category.toLowerCase() === "tier") {
            if (!this.finalData.hasOwnProperty("tiers")) {
              this.finalData["tiers"] = [];
            }
            this.finalData["tiers"].push(req.id);
          }
          if (req.category.toLowerCase() === "segment") {
            this.finalData["segments"].push(req.id);
          }
          if (req.category.toLowerCase() === "customerlist") {
            if (!this.finalData.hasOwnProperty("customerListIds")) {
              this.finalData["customerListIds"] = [];
            }
            this.finalData["customerListIds"].push(req.id);
          }
          if (req.category.toLowerCase() === "employeelist") {
            if (!this.finalData.hasOwnProperty("employeeListIds")) {
              this.finalData["employeeListIds"] = [];
            }
            this.finalData["employeeListIds"].push(req.id);
          }
        });
      }
    }
    //If method is called from random coupons pool then we need to send the data to coupon pool component
    if (this.showViewForCouponPool) {
      return this.finalData;
    }
    this.apiCall.sendGiftCode(this.finalData).subscribe(
      (response) => {
        if (response["message"] === "SUCCESS") {
          const dialogRef = this.dialog.open(SuccessDialogComponent, {
            panelClass: "no-padding-dialog-popup",
            width: "20%",
            disableClose: true,
            data: {
              message: this._i18nDynamicTranslate.transform(
                "Gift Code created sucessfully.",
                ["POS_PAGE"]
              ),
              buttonText: this._i18nDynamicTranslate.transform(
                "Redirect to Listing Page",
                ["POS_PAGE"]
              ),
            },
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.router.navigate(["/app/offer/giftcode"]);
          });
        } else {
          this.snackBar.openSnackBar(
            this._i18nDynamicTranslate.transform("Failed to send gift code", [
              "POS_PAGE",
            ]),
            2000
          );
        }
      },
      (error) => {
        console.log(error);
        this.snackBar.openSnackBar(
          this._i18nDynamicTranslate.transform("Error sending gift code", [
            "POS_PAGE",
          ]),
          2000
        );
      }
    );
  }

  saveGiftCode() {
    if(this.giftCodeType === "EWALLET") {
      this.walletExpiryConfiguration = this.giftCodeWalletConfig.getExpirationData();
    }
    if(this.giftCodeType === "LOYALTY_POINTS") {
      this.loyaltyExpiryConfig = this.profileLoyaltyConfig.getExpirationData();
    }

    if(this.loyaltyExpiryConfig && this.giftCodeType === "LOYALTY_POINTS"){
      this.loyaltyExpiryConfig.validityDate = this.loyaltyExpiryConfig.validityDate?.replace("T", " ");
    } 

    this.finalData = {
      name: this.offerTemplateName,
      rewardType: this.giftCodeType,
      rewardValue:
        this.giftCodeType === "LOYALTY_POINTS"
          ? this.loyaltyPoints
          : this.eWallet,
      createdBy:
        this.tokenStorage.getqId() === "null"
          ? this.adminCreated
          : this.storeDataJSON,
      adminCreated: this.tokenStorage.getqId() === "null" ? true : false,
      codeLength: parseInt(this.codeLength),
      autoreserve: this.isAutoreserve,
      programExpWalletConfig: this.giftCodeType === "EWALLET" ? JSON.stringify(this.walletExpiryConfiguration) : null,
      loyaltyPointsExpiry: this.giftCodeType === "LOYALTY_POINTS" ? JSON.stringify(this.loyaltyExpiryConfig) : null,
    };
    if (this.giftcodeAliasName.length > 0) {
      this.finalData.giftcodeAliasName = this.giftcodeAliasName;
    }
    if (this.giftCodeType == "EWALLET") {
      this.finalData.ledgerId = this.selectedLedgerId;
    }
    if (this.customTermsAndCondition.trim()) {
      this.finalData.termsConditions = JSON.stringify(
        this.updateBulletArray(this.customTermsAndCondition)
      );
    }
    if (this.customAliasDescription.trim()) {
      this.finalData.aliasTermsConditions = JSON.stringify(
        this.updateBulletArray(this.customAliasDescription)
      );
    }
    if (this.customDescription.trim()) {
      this.finalData.description = JSON.stringify(
        this.updateBulletArray(this.customDescription)
      );
    }
    if (this.customAliasDescription.trim()) {
      this.finalData.aliasDescription = JSON.stringify(
        this.updateBulletArray(this.customAliasDescription)
      );
    }
    this.apiCall
      .updateParticularGiftCodeDetails(this.queryparamofferId, this.finalData)
      .subscribe(
        (response) => {
          if (response) {
            const dialogRef = this.dialog.open(SuccessDialogComponent, {
              panelClass: "no-padding-dialog-popup",
              width: "20%",
              disableClose: true,
              data: {
                message: this._i18nDynamicTranslate.transform(
                  "Gift Code updated sucessfully.",
                  ["POS_PAGE"]
                ),
                buttonText: this._i18nDynamicTranslate.transform(
                  "Redirect to Listing Page",
                  ["POS_PAGE"]
                ),
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              this.router.navigate(["/app/offer/giftcode"]);
            });
          }
        },
        (error) => {
          console.log(error);
          this.snackBar.openSnackBar(
            this._i18nDynamicTranslate.transform("Error updating gift code", [
              "POS_PAGE",
            ]),
            2000
          );
        }
      );
  }

  aliasInitializeBulletPoint(type): void {
    if (type === "description") {
      if (!this.customAliasDescription.trim()) {
        this.customAliasDescription = "\u2022 "; // Add the first bullet point
      }
    } else {
      if (!this.customAliasTermsAndCondition.trim()) {
        this.customAliasTermsAndCondition = "\u2022 "; // Add the first bullet point
      }
    }
  }

  initializeBulletPoint(type): void {
    if (type === "description") {
      if (!this.customDescription.trim()) {
        this.customDescription = "\u2022 "; // Add the first bullet point
      }
    } else {
      if (!this.customTermsAndCondition.trim()) {
        this.customTermsAndCondition = "\u2022 "; // Add the first bullet point
      }
    }
  }

  handleKeyDown(event: KeyboardEvent, type): void {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default "Enter" behavior

      const textarea = event.target as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Insert a newline and bullet point
      const bulletPoint = "\u2022 ";
      if (type === "description") {
        const newValue =
          this.customDescription.substring(0, start) + // Content before cursor
          "\n" +
          bulletPoint + // New line and bullet
          this.customDescription.substring(end); // Content after cursor

        this.customDescription = newValue;
      } else if (type === "terms") {
        const newValue =
          this.customTermsAndCondition.substring(0, start) + // Content before cursor
          "\n" +
          bulletPoint + // New line and bullet
          this.customTermsAndCondition.substring(end); // Content after cursor

        this.customTermsAndCondition = newValue;
      }

      // this.updateBulletArray(type);

      // Move the cursor to the right of the new bullet point
      setTimeout(() => {
        textarea.setSelectionRange(
          start + bulletPoint.length + 1,
          start + bulletPoint.length + 1
        );
        this.scrollToCursor(textarea);
      });
    }
  }

  aliasHandleKeyDown(event: KeyboardEvent, type): void {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default "Enter" behavior

      const textarea = event.target as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Insert a newline and bullet point
      const bulletPoint = "\u2022 ";
      if (type === "description") {
        const newValue =
          this.customAliasDescription.substring(0, start) + // Content before cursor
          "\n" +
          bulletPoint + // New line and bullet
          this.customAliasDescription.substring(end); // Content after cursor

        this.customAliasDescription = newValue;
      } else if (type === "terms") {
        const newValue =
          this.customAliasTermsAndCondition.substring(0, start) + // Content before cursor
          "\n" +
          bulletPoint + // New line and bullet
          this.customAliasTermsAndCondition.substring(end); // Content after cursor

        this.customAliasTermsAndCondition = newValue;
      }

      // this.updateBulletArray(type);

      // Move the cursor to the right of the new bullet point
      setTimeout(() => {
        textarea.setSelectionRange(
          start + bulletPoint.length + 1,
          start + bulletPoint.length + 1
        );
        this.scrollToCursor(textarea);
      });
    }
  }

  private scrollToCursor(textarea: HTMLTextAreaElement): void {
    const cursorPosition = textarea.selectionStart;
    const textBeforeCursor = textarea.value.substring(0, cursorPosition);
    const lines = textBeforeCursor.split("\n");

    // Calculate the height of the content above the cursor
    const lineHeight = parseInt(
      window.getComputedStyle(textarea).lineHeight || "20",
      10
    );
    const scrollHeight = lines.length * lineHeight;

    // Scroll to the calculated height
    textarea.scrollTop = scrollHeight - textarea.clientHeight + lineHeight;
  }

  numberInputHandler(event: KeyboardEvent, maxLength) {
    const invalidCharacters = ["e", "-", "+", "."];
    const inputValue = (event.target as HTMLInputElement).value;
    if (
      (inputValue.length >= maxLength && event.key !== "Backspace") ||
      invalidCharacters.includes(event.key)
    ) {
      event.preventDefault();
    }
  }

  giftCodeTypeRadioChange(value) {
    if (value === "LOYALTY_POINTS") {
      this.loyaltyPoints = 0;
    }
    if (value === "EWALLET") {
      this.eWallet = 0;
    }
  }

  changeSegmentSelection() {
    const hasNumber =
      this.templateDispatchForm.controls.dispatchcustomerSegments["value"].some(
        (item) => typeof item === "number"
      );
    if (
      this.templateDispatchForm.controls.dispatchcustomerSegments[
        "value"
      ].includes("ALL_CUSTOMERS")
    ) {
      this.disableCustomerSegmentSelection = true;
    } else if (
      !this.templateDispatchForm.controls.dispatchcustomerSegments[
        "value"
      ].includes("ALL_CUSTOMERS") &&
      hasNumber
    ) {
      this.disableAllCustomerSelection = true;
    } else {
      this.disableAllCustomerSelection = false;
      this.disableCustomerSegmentSelection = false;
    }
    if (
      this.templateDispatchForm.controls.dispatchcustomerSegments["value"]
        .length === 0
    ) {
      this.selectedSegments = [];
      this.disableAllCustomerSelection = false;
      this.disableCustomerSegmentSelection = false;
      this.customerCount = 0;
      this.totalCustomer = 0;
      this.InvalidCustomer = 0;
    }
    // this.getCustomerCount();
  }

  getCustomerSegmentsAndTiers() {
    this.apiCall.getCustomerSegmentsAndTiers().subscribe(
      (response) => {
        let res = response["body"];
        for (let i = 0; i < res.length; i++) {
          if (res[i].category.toLowerCase() === "segment") {
            this.customerSegmentList.push({
              id: res[i]["id"],
              name: res[i]["segmentName"],
              isActive: res[i]["isActive"],
              status: false,
              category: res[i]["category"],
              createdBy: res[i]["createdBy"],
            });
          }
          if (res[i].category.toLowerCase() === "tier") {
            this.customerTierList.push({
              id: res[i]["id"],
              name: res[i]["segmentName"],
              isActive: res[i]["isActive"],
              status: false,
              category: res[i]["category"],
            });
          }
          if (res[i].category.toLowerCase() === "customerlist") {
            this.customerList.push({
              id: res[i]["id"],
              name: res[i]["segmentName"],
              isActive: res[i]["isActive"],
              status: false,
              category: res[i]["category"],
              createdBy: res[i]["createdBy"],
            });
          }
          if (res[i].category.toLowerCase() === "employeelist") {
            this.employeeList.push({
              id: res[i]["id"],
              name: res[i]["segmentName"],
              isActive: res[i]["isActive"],
              status: false,
              category: res[i]["category"],
            });
          }
        }
        this.filterCustomerLists();
        this.filterSegments();
      },
      (error) => {
        this.snackBar.openSnackBar(
          this._i18nDynamicTranslate.transform(
            "Error fetching getCustomerSegmentsAndTiers data",
            ["POS_PAGE"]
          ),
          2000
        );
      }
    );
  }

  filterCustomerLists() {
    this.storeCreatedCustomList = this.customerList.filter(
      (segment) => segment.createdBy?.storeId === this.storeId
    );
    this.otherCustomList = this.customerList.filter(
      (segment) => segment.createdBy?.storeId !== this.storeId
    );
  }

  filterSegments() {
    this.storeCreatedSegments = this.customerSegmentList.filter(
      (segment) => segment.createdBy?.storeId === this.storeId
    );
    this.otherSegments = this.customerSegmentList.filter(
      (segment) => segment.createdBy?.storeId !== this.storeId
    );
  }

  selectopenclose(value) {
    this.templateDispatchForm.controls.tempsegmentFilter.setValue("");
    switch (value) {
      case "customerSegmentsSelect":
        this.customerSegmentsSelect.open();
        break;
    }
  }

  selectCustomer() {
    const dialogRef = this.dialog.open(TargetSpecificCustomerComponent, {
      panelClass: "no-padding-dialog-popup",
      height: "90%",
      width: "95%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.selectedCustomer = result.selectedCustomer;
        this.selectedCustomerDetails = result.selectedCustomerDetails;
        console.log("Selected Customer:", this.selectedCustomerDetails);
      }
    });
  }

  isChannelChecked2(channel) {
    if (
      this.selectedChannelList.find(
        (item) => item.toLowerCase() === channel.toLowerCase()
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkChannel(channel) {
    if (this.isChannelChecked2(channel)) {
      this.selectedChannelList = this.selectedChannelList.filter(
        (ele) => ele.toLowerCase() != channel.toLowerCase()
      );
    } else {
      this.selectedChannelList.push(channel);
    }
    this.channelConfigureStatus = false;
    this.onSelectChange(channel);
    // this.getCustomerCount();
  }

  onSelectChange(value) {
    this.selectedChannel = this.selectedChannelList[0]?.toUpperCase();
    // if (this.selectedChannelList.indexOf("SMS") === -1) {
    //   this.currentTimeMin = "00:00";
    // } else {
    //   this.templateDispatchForm.get("dispatchTime").setValue("");
    //   this.currentTimeMin = "10:00 AM";
    // }
  }

  // getCustomerCount() {
  //   this.segmentLength = false;
  //   this.customerCount = 0;
  //   this.NotAllowedCustomer = 0;
  //   this.ValidCustomerCount = 0;
  //   this.totalCustomer = 0;
  //   this.UnsubscribedCount = 0;

  //   this.selectedSegments = this.customerSegmentsSelect?.value
  //     ? this.customerSegmentsSelect?.value
  //     : "";

  //   let selectedTiers = [],
  //     selectedSegments = [],
  //     selectedCustomerList = [],
  //     selectedEmployeeList = [];

  //   if (this.selectedSegments && this.selectedSegments.length > 0) {
  //     this.selectedSegments.forEach((selectedSegment) => {
  //       let req = [
  //         ...this.customerSegmentList,
  //         ...this.customerTierList,
  //         ...this.customerList,
  //         ...this.employeeList,
  //       ].find((segment) => selectedSegment === segment.id);
  //       if (req?.category.toLowerCase() === "tier") {
  //         selectedTiers.push(req);
  //       }
  //       if (req?.category.toLowerCase() === "segment") {
  //         selectedSegments.push(req);
  //       }
  //       if (req?.category.toLowerCase() === "customerlist") {
  //         selectedCustomerList.push(req);
  //       }
  //       if (req?.category.toLowerCase() === "employeelist") {
  //         selectedEmployeeList.push(req);
  //       }
  //     });
  //   }

  //   let targetedStores = [];
  //   if(this.isAdminPos) {
  //     if(this.templateDispatchForm.controls.targetedStores?.value.some(id=>id==-1)) { //check if all stores selected
  //       targetedStores = [];
  //     } else {
  //       this.templateDispatchForm.controls.targetedStores?.value.forEach(id=>targetedStores.push(parseInt(id)));
  //     }
  //   } else {
  //     targetedStores.push(parseInt(this.storeDataJSON['storeId']));
  //   }
  //   if (
  //     this.disableCustomerSegmentSelection != false ||
  //     this.disableAllCustomerSelection != false || this.selectedSegments.includes("LEADS")
  //   ) {
  //     if (this.selectedSegments?.length != 0) {
  //       this.segmentLength = true;
  //       let isSegmented = this.selectedSegments[0] != "ALL_CUSTOMERS";
  //       let data = {
  //         isSegmented: (selectedSegments.length > 0 || selectedTiers.length > 0 || selectedCustomerList.length > 0 || selectedEmployeeList.length > 0)
  //           ? true
  //           : false,
  //         isLead: this.selectedSegments.includes("LEADS") ? true : false,
  //         isCustomer: this.selectedSegments.includes("ALL_CUSTOMERS")
  //           ? true
  //           : false,
  //         customerSegmentIds: isSegmented
  //           ? selectedSegments.map((s) => s.id)
  //           : null,
  //         customerTierIds: isSegmented ? selectedTiers.map((t) => t.id) : null,
  //         customerListIds: isSegmented
  //           ? selectedCustomerList.map((c) => c.id)
  //           : null,
  //         channel: this.selectedChannelList,
  //         targetedStoreIds: targetedStores,
  //       };

  //       this.apiCall.getCustomerCount(data).subscribe((response) => {
  //         this.apiloading = true;
  //         if (response["body"].totalCount !== null) {
  //           this.totalCustomer = response["body"].totalCount;
  //         }
  //         if (response["body"].invalidNumberCount !== null) {
  //           this.InvalidCustomer = response["body"].invalidNumberCount;
  //         }
  //         if (response["body"].unsubscribedCount !== null) {
  //           this.UnsubscribedCount = response["body"].unsubscribedCount;
  //         }
  //         if (
  //           response["body"].unsubscribedCount !== null &&
  //           response["body"].totalCount !== null
  //         ) {
  //           this.ValidCustomerCount =
  //             response["body"].totalCount - response["body"].unsubscribedCount;
  //         }
  //         if(this.ValidCustomerCount>0){
  //           this.smsNoOfCustomersZeroError = "";
  //         }

  //         this.apiloading = false;
  //       });
  //     } else {
  //       this.segmentLength = false;
  //     }
  //   }
  // }

  selectChannel(value) {
    this.channelConfigureStatus = false;
    this.selectedChannel = value;
    // if (this.templateDispatchForm["value"]["dispatchType"] === "SCHEDULED") {
    //   this.checkTypeTime();
    // }
    if (this.selectedChannelList.indexOf("SMS") === -1) {
      this.currentTimeMin = "00:00";
    } else {
      this.currentTimeMin = "10:00 AM";
    }
  }

  getId(channel) {
    switch (channel) {
      case "SMS":
        return 18;
      case "Email":
        return 10;
      case "WhatsApp":
        return 41;
      case "appOnly":
        return 50;
      case "POS":
        return 52;
      case "pushNotification":
        return 55;
      case "leads":
        return 57;
    }
  }

  validateAllRequiredFields() {
    if (!this.offerTemplateName || this.offerTemplateName.trim().length === 0) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Gift code name is required", [
          "POS_PAGE",
        ]),
        2000
      );
      return 1;
    }
    if (
      !this.showViewForCouponPool &&
      this.giftCodeTargetAudience === "INDIVIDUAL_CUSTOMER" &&
      !this.selectedCustomer
    ) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Select at least one customer", [
          "POS_PAGE",
        ]),
        2000
      );
      return 1;
    }

    if (
      !this.showViewForCouponPool &&
      this.giftCodeTargetAudience === "CUSTOMER_SEGMENTS" &&
      (!this.templateDispatchForm.controls.dispatchcustomerSegments.value ||
        this.templateDispatchForm.controls.dispatchcustomerSegments.value
          .length === 0)
    ) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Select at least one segment", [
          "POS_PAGE",
        ]),
        2000
      );
      return 1;
    }

    if (
      this.giftCodeType === "LOYALTY_POINTS" &&
      (this.loyaltyPoints || this.loyaltyPoints <= 0)
    ) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "Loyalty points should be greater than zero",
          ["POS_PAGE"]
        ),
        2000
      );
      return 1;
    }
    console.log("codeLength", this.codeLength);
    if (
      !this.showViewForCouponPool &&
      (!this.codeLength || this.codeLength < 4)
    ) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "Gift Code length should be greater than three",
          ["POS_PAGE"]
        ),
        2000
      );
      return 1;
    }

    if (!this.showViewForCouponPool && this.codeLength > 20) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "Gift Code length should be less than 20",
          ["POS_PAGE"]
        ),
        2000
      );
      return 1;
    }

    if (
      this.giftCodeType === "EWALLET" &&
      (!this.eWallet || this.eWallet <= 0)
    ) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform(
          "E-Wallet amount should be greater than zero",
          ["POS_PAGE"]
        ),
        2000
      );
      return 1;
    }

    if (this.expiryDate.invalid) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Expiry date is required", [
          "POS_PAGE",
        ]),
        2000
      );
      return 1;
    }
    if (!this.showViewForCouponPool && this.selectedChannelList.length > 0) {
      return this.checkVaidationSchedule();
    }
    return 0;
  }

  checkVaidationSchedule() {
    if (this.selectedChannelList.length > 1) {
      let whastappcheck = this.checkWhastapp();
      let emailCheck = this.checkEmail();
      let smsCheck = this.checkSMS();
      let pushNotificationCheck = this.checkPushNotification();

      if (whastappcheck && smsCheck && emailCheck && pushNotificationCheck) {
        return 0;
      } else {
        return 1;
      }
    } else {
      this.errorChannelSelect = "";
      return 0;
    }
  }

  checkEmail() {
    if (this.selectedChannelList.indexOf("Email") != -1) {
      if (this.preemailLayoutId == null) {
        this.attachEmailError = this._i18nDynamicTranslate.transform(
          "Select email template",
          ["POS_PAGE"]
        );
        return 0;
      } else if (this.selectedEmailTemplateId == null) {
        this.attachEmailError = this._i18nDynamicTranslate.transform(
          "Select email template",
          ["POS_PAGE"]
        );
        return 0;
      } else {
        if (
          this.selectedChannelList.length > 0 &&
          this.selectedChannelList.indexOf("Email") != -1
        ) {
          if (!this.offerEmailSubject) {
            this.offerEmailSubjectErrorText = "Please enter subject";
            return 0;
          } else if (this.offerEmailSubject.length < 3) {
            this.offerEmailSubjectErrorText = "Minimum 3 Characters";
            return 0;
          } else {
            this.offerEmailSubjectErrorText = null;
            return 1;
          }
        } else {
          return 1;
        }
      }
    } else {
      return 1;
    }
  }

  checkSMS() {
    if (this.selectedChannelList.indexOf("SMS") != -1) {
      if (this.presmsrewardId == null) {
        this.attachSmsError = this._i18nDynamicTranslate.transform(
          "Select SMS template",
          ["POS_PAGE"]
        );
        return 0;
      }
      // else if (
      //   this.showSMSWarning !== 1 &&
      //   this.templateDispatchForm["value"]["dispatchType"] != "SCHEDULED" &&
      //   this.action === "DISPATCH"
      // ) {
      //   return 0;
      // }
      else {
        return 1;
      }
      ("");
    } else {
      return 1;
    }
  }
  checkWhastapp() {
    if (this.selectedChannelList.indexOf("WhatsApp") != -1) {
      if (this.prewhatsappLayoutId == null) {
        this.attachWhatsappError = this._i18nDynamicTranslate.transform(
          "Select WhatsApp template",
          ["POS_PAGE"]
        );
        return 0;
      } else {
        return 1;
      }
    } else {
      return 1;
    }
  }

  checkPushNotification() {
    if (
      this.selectedChannelList.length > 0 &&
      this.selectedChannelList.indexOf("pushNotification") != -1
    ) {
      if (!this.offerPushNotificationSubject) {
        this.offerPushNotificationErrorText = "Please enter subject";
        return 0;
      } else if (this.offerPushNotificationSubject.length < 3) {
        this.offerPushNotificationErrorText = "Minimum 3 Characters";
        return 0;
      } else {
        this.offerPushNotificationErrorText = null;
        return 1;
      }
    } else {
      return 1;
    }
  }

  openchannelEmailDiv() {
    this.attachEmailError = "";
    this.prerewardId = null;
    this.channelConfigureStatus = true;

    //get all custom emails from template getAllEmailLayouts api result
    this.otherEmailTemplateList = [];
    if (this.templateList.length > 0) {
      this.templateList.forEach((template) => {
        if (template.emailType == "CUSTOM") {
          this.otherEmailTemplateList.push(template);
        }
      });
    }
    //filter out discount type reward email from all getRewardEmails api result
    let idsToFilterOut = this.offerDiscountTypeEmailTemplateList.map(
      (template) => template.id
    );
    this.otherEmailTemplateList = [
      ...this.otherEmailTemplateList,
      ...this.rewardTemplateList.filter(
        (template) => !idsToFilterOut.includes(template.id)
      ),
    ];
    this.otherEmailTemplateList.sort((a, b) => {
      const dateA: Date = new Date(a.lastModifiedTime);
      const dateB: Date = new Date(b.lastModifiedTime);
      return dateB.getTime() - dateA.getTime();
    });
    // console.log('DISCOUNT TYPE EMAILS',this.offerDiscountTypeEmailTemplateList);
    // console.log('FILTERED-->',this.otherEmailTemplateList);
  }

  getTemplates(preSelectId?) {
    this.loading = true;
    this.apiCall.listEmailLayout().subscribe((response) => {
      if (response["message"] === "success") {
        this.templateList = response["body"];
        if (this.templateList.length > 0) {
          this.templateList.forEach((template) => {
            template["name"] = template.layoutName;
            template["tableType"] = "CAMPAIGN";
          });
        }
        var i;
        this.loading = false;
        if (preSelectId) {
          this.selectedEmailTemplateId = preSelectId;
          const preSelectedTempalte = this.templateList.find(
            (template) => template.id == preSelectId
          );
          if (preSelectedTempalte) {
            this.selectedEmailTemplateName = preSelectedTempalte.layoutName;
            this.selectedTemplateTableType = "CAMPAIGN";
            this.onEmailSave();
          }
        }
      } else {
        // this.snackBar.openSnackBar("Error", 2000);
      }
    });
  }

  onEmailSave() {
    this.preemailLayoutId = this.selectedEmailTemplateId;
    this.preemailLayoutName = this.selectedEmailTemplateName;
    this.preemailTableType = this.selectedTemplateTableType;
    this.channelConfigureStatus = false;
  }

  stringInputHandler(event: KeyboardEvent, maxLength, comparisonStatement?) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length >= maxLength && event.key !== "Backspace") {
      event.preventDefault();
    }
  }

  opensnapshotHtmlDialog(id, tableType?) {
    var dat = {
      type: null,
      id: null,
      channel: null,
      templateID: null,
      rewardType: null,
      actionType: null,
    };

    if (id != null) {
      dat = {
        type: tableType.toLowerCase(),
        id: id,
        channel: this.selectedChannel,
        templateID: null,
        rewardType: "GiftCode",
        actionType: "Offer",
      };
    } else {
      dat = {
        type: this.preemailTableType.toLowerCase(),
        id: this.preemailLayoutId,
        channel: this.selectedChannel,
        templateID: null,
        rewardType: "GiftCode",
        actionType: "Offer",
      };
    }
    const dialogRef = this.dialog.open(HtmlForEmailTemplatesDialogComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "60%",
      height: "500px",
      data: dat,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "edit") {
        if (id) {
          this.loadEmailEditorReward(id, tableType);
        } else {
          this.loadEmailEditorReward(
            this.preemailLayoutId,
            this.preemailTableType
          );
        }
      }
    });
  }

  loadEmailEditorReward(id?, tableType?) {
    var specialTagType = null;
    var imageTagStatus = false;
    this.finalScreenHeight = this.scrHeight - 61;
    this.finalScreenWidth = this.scrWidth;
    let sh = this.finalScreenHeight * (90 / 100);
    let sw = this.finalScreenWidth * (90 / 100);
    if (this.prerewardId == null) {
      var datas = {
        process: "createRewardTemplateLayout",
        id: id,
        tags: [],
        imageTagStatus: false,
        specialTagType: "",
        offerId: null,
        type: "OFFER",
        rewardType: "Giftcode",
        isReward: true,
        tableType: tableType,
      };
    } else {
      var datas = {
        process: "createRewardTemplateLayout",
        id: this.prerewardId,
        tags: [],
        imageTagStatus: false,
        specialTagType: "",
        offerId: null,
        type: "OFFER",
        rewardType: "Giftcode",
        isReward: true,
        tableType: tableType,
      };
    }
    this.getRewardOfferTags(datas, imageTagStatus, specialTagType, sh, sw);
  }
  data = {
    process: "create",
    id: "null",
    tags: [],
    imageTagStatus: true,
    offerId: null,
    saveName: null,
    isReward: false,
    type: "EMAIL_LAYOUT_HTML",
    rewardType: null,
  };

  getRewardOfferTags(datas, imageTagStatus, specialTagType, sh, sw) {
    this.apiCall.getRewardOfferTags("Giftcode").subscribe((response) => {
      if (response["message"] === "success") {
        let messageVariables = JSON.parse(response["body"]);
        let finalVariables = [];
        for (let key in messageVariables) {
          finalVariables.push({
            name: messageVariables[key],
            value: key,
          });
        }
        this.data.tags = finalVariables;
        datas.tags = finalVariables;
        datas.imageTagStatus = imageTagStatus;
        datas.specialTagType = specialTagType;
        // datas.offerId = this.offerId;
        this.openOfferEmailDialog(sh, sw, datas);
      } else {
        // this.snackBar.openSnackBar(
        //   this._i18nDynamicTranslate.transform(
        //     "Fetching template variable failed",
        //     ["POS_PAGE"]
        //   ),
        //   2000
        // );
      }
    });
    (err) => {
      // this.snackBar.openSnackBar(
      //   this._i18nDynamicTranslate.transform(
      //     "Fetching message template variable failed",
      //     ["POS_PAGE"]
      //   ),
      //   2000
      // );
    };
  }

  openOfferEmailDialog(sh, sw, datas) {
    const dialogRefer = this.dialog.open(OfferAttachEmailDialogComponent, {
      panelClass: "customAttachEmail",
      height: sh + "px",
      width: sw + "px",
      maxWidth: "99vw",
      minWidth: "1250px",
      minHeight: "620px",
      disableClose: true,
      data: datas,
    });
    dialogRefer.afterClosed().subscribe((result) => {
      if (result) {
        if (result.tableType == "REWARD") {
          this.getrewardemail(result.layoutId);
          this.getEmailTemplate(result.layoutId);
        } else {
          this.getTemplates(result.layoutId);
        }
      }
    });
  }

  getEmailTemplate(preSelectId?) {
    this.offerDiscountTypeEmailTemplateList = [];
    this.apiCall
      .getEmailTemplateOffers(123, "Reward", "OFFER")
      .subscribe((response) => {
        this.emailResponse = response["body"];
        this.offerDiscountTypeEmailTemplateList = this.emailResponse.Reward;
        this.offerDiscountTypeEmailTemplateList.sort((a, b) => {
          const dateA: Date = new Date(a.lastModifiedTime);
          const dateB: Date = new Date(b.lastModifiedTime);
          return dateB.getTime() - dateA.getTime();
        });
        this.offerDiscountTypeEmailTemplateList.forEach(
          (template) => (template["tableType"] = "REWARD")
        );
        if (preSelectId) {
          this.selectedEmailTemplateId = preSelectId;
          const preSelectedTempalte =
            this.offerDiscountTypeEmailTemplateList.find(
              (template) => template.id == preSelectId
            );
          if (preSelectedTempalte) {
            this.selectedEmailTemplateName = preSelectedTempalte.name;
            this.selectedTemplateTableType = "REWARD";
            this.onEmailSave();
          }
        }
      });
  }

  selectTemplate(
    type: string,
    id: number,
    templateName: string,
    tableType?,
    isNonDiscountTypeEmailPicked?: boolean
  ) {
    if (type === "EMAIL") {
      this.selectedEmailTemplateId = id;
      this.selectedEmailTemplateName = templateName;
      this.selectedTemplateTableType = tableType;
      this.isNonDiscountTypeEmailPicked = isNonDiscountTypeEmailPicked
        ? isNonDiscountTypeEmailPicked
        : false;
    }
  }

  selectSMStemplateOBJ(layout, id, isNonDiscountTypeSMSPicked?) {
    this.selectedSmsTemporaryId = id;
    let type = this.selectedSmsOfferPart;
    this.rewardSMSLayoutJson = layout;
    this.isNonDiscountTypeSMSPicked = isNonDiscountTypeSMSPicked
      ? isNonDiscountTypeSMSPicked
      : false;
  }

  openchannelSMSDiv(type) {
    this.attachSmsError = "";
    this.selectedSmsOfferPart = type;
    this.channelConfigureStatus = true;
  }

  opensmsPreviewDialog(id) {
    const dialogRef = this.dialog.open(SmsPreviewIdDialogComponent, {
      panelClass: "sms-preview-dialog",
      data: id,
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openSMSPreview(layout) {
    const dialogRef = this.dialog.open(SmsPreviewDialogComponent, {
      panelClass: "sms-preview-dialog",
      data: {
        smsText: layout["layoutData"],
        type: "SMS",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openWhatsAppPreview(layoutData) {
    let layout = JSON.parse(layoutData);
    const dialogRef = this.dialog.open(SmsPreviewDialogComponent, {
      panelClass: "sms-preview-dialog",
      data: {
        smsText: layout,
        type: "WhatsApp",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  openchannelWhatsappDiv() {
    this.attachWhatsappError = "";
    this.channelConfigureStatus = true;
    this.whatsAppTemplateList = this.whatsAppResponse.Reward;
  }

  getOfferSMSTemplate(preSelectId?) {
    let offerType = "Reward";
    // To be understood why offerId is passed here?
    let offerId = 11655;
    this.apiCall
      .getOfferSMSTemplate(offerId, offerType)
      .subscribe((response) => {
        if (
          response["message"] == "success" ||
          response["message"] == "SUCCESS"
        ) {
          this.smsResponse = response["body"];
          if (preSelectId) {
            const preSelectedTempalte = this.smsResponse.Reward?.find(
              (template) => template.id == preSelectId
            );
            this.presmsrewadLayoutName = preSelectedTempalte.name;
            this.presmsrewardId = preSelectedTempalte.id;
          }
        }
      });
  }

  getAllCustomSmsTemplates(preSelectId?) {
    this.customSmsTemplateList = [];
    let layoutAPI = this.apiCall
      .getSmsTemplates("SMS", "SMS")
      .subscribe((response) => {
        this.smsTemplateList = response["body"];
        if (this.smsTemplateList.length > 0) {
          this.smsRewardTemplateList = this.smsTemplateList.filter(
            (layout) => layout["type"] == "GiftCode"
          );
          this.customSmsTemplateList = this.smsTemplateList.filter(
            (layout) => layout["layoutType"] == "CUSTOM"
          );
          this.customSmsTemplateList.sort((a, b) => {
            const dateA: Date = new Date(a.lastModifiedTime);
            const dateB: Date = new Date(b.lastModifiedTime);
            return dateB.getTime() - dateA.getTime();
          });
          if (preSelectId) {
            const preSelectedTempalte = this.smsTemplateList.find(
              (template) => (template.id = preSelectId)
            );
            this.presmsrewadLayoutName = preSelectedTempalte.name;
            this.presmsrewardId = preSelectedTempalte.id;
          }
        }
      });
  }

  getWhatsAppTemplate() {
    // To understand and change why offerId is required
    let offerId = 11655;
    this.apiCall
      .getOfferWhatsAppTemplate(offerId, "Reward", "OFFER")
      .subscribe((response) => {
        this.whatsAppResponse = response["body"];
      });
  }

  getrewardemail(preSelectId?) {
    this.apiCall.getRewardEmailList().subscribe((result) => {
      this.rewardTemplateList = result["body"];
      if (this.rewardTemplateList.length == 0) {
        // this.snackBar.openSnackBar(
        //   this._i18nDynamicTranslate.transform(
        //     "No Reward Templates available. Cannot send giftcode",
        //     ["POS_PAGE"]
        //   ),
        //   2000
        // );
        return 0;
      }
      for (let i = 0; i < this.rewardTemplateList.length; i++) {
        if (this.rewardTemplateList[i]["layoutName"] == "GiftCode") {
          this.mainRewardtemplate = this.rewardTemplateList[i]["id"];
        }
        this.rewardTemplateList[i]["name"] =
          this.rewardTemplateList[i]["layoutName"];
        this.rewardTemplateList[i]["tableType"] = "REWARD";
      }
      // Extract offerDiscountTypeEmailTemplateList (where type is 'GiftCode')
      this.offerDiscountTypeEmailTemplateList = this.rewardTemplateList.filter(
        (template) => template["type"] === "GiftCode"
      );

      // Sort by lastModifiedTime (if available)
      this.offerDiscountTypeEmailTemplateList.sort((a, b) => {
        const dateA: Date = new Date(a.lastModifiedTime);
        const dateB: Date = new Date(b.lastModifiedTime);
        return dateB.getTime() - dateA.getTime();
      });

      if (preSelectId) {
        this.selectedEmailTemplateId = preSelectId;
        const preSelectedTempalte = this.rewardTemplateList.find(
          (template) => template.id == preSelectId
        );
        if (preSelectedTempalte) {
          this.selectedEmailTemplateName = preSelectedTempalte.layoutName;
          this.selectedTemplateTableType = "REWARD";
          this.onEmailSave();
        }
      }
      // console.log('ALL REWARD EMAILS',this.rewardTemplateList)
    });
  }

  cancelSMSSave() {
    this.selectedSmsTemporaryId = null;
    this.channelConfigureStatus = false;
  }

  cancelEmailSave() {
    this.selectedEmailTemplateId = null;
    this.channelConfigureStatus = false;
  }

  cancelWhatsAppSave() {
    this.selectedWhatsAppTemporaryId = null;
    this.channelConfigureStatus = false;
  }

  onWhatsAppSave() {
    this.prewhatsappLayoutName = this.rewardWhatsAppLayoutJson.name;
    this.prewhatsappLayoutId = this.rewardWhatsAppLayoutJson.id;
    this.prewhatsappLayoutData = this.rewardWhatsAppLayoutJson.layoutData;
    this.selectedWhatsAppTemporaryId = null;
    this.channelConfigureStatus = false;
  }

  onSMSSave() {
    if (this.selectedSmsTemporaryId == null) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Select any template", [
          "POS_PAGE",
        ]),
        2000
      );
      return;
    }
    this.presmsrewadLayoutName = this.rewardSMSLayoutJson.name;
    this.presmsrewardId = this.rewardSMSLayoutJson.id;
    this.selectedSmsTemporaryId = null;
    this.channelConfigureStatus = false;
  }

  selectWhatsApptemplateOBJ(layout, id) {
    this.selectedWhatsAppTemporaryId = id;
    this.rewardWhatsAppLayoutJson = layout;
    // console.log("LAYOUT", this.rewardWhatsAppLayoutJson);
  }

  updateBulletArray(value): void {
    let reuslt = value
      .split("\n") // Split by new lines
      .map((line) => line.trim()) // Remove extra spaces
      .filter((line) => line.startsWith("\u2022")) // Include only lines that start with a bullet
      .map((line) => line.substring(2).trim());

    return reuslt;
  }

  keypressNumber(event) {
    if (
      [46, 8, 9, 27, 13].includes(event.keyCode) ||
      // Allow: Ctrl+A/Ctrl+C/Ctrl+V/Ctrl+X
      (event.keyCode === 65 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 67 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 86 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      (event.keyCode === 88 &&
        (event.ctrlKey === true || event.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (event.keyCode >= 35 && event.keyCode <= 40)
    ) {
      // Let it happen, don't do anything
      return;
    }
    // Ensure that it's a number and stop the keypress if it's not
    if (
      (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }

  getCommunication() {
    var commu: any = {};
    let data1: any = {};
    for (let i = 0; i < this.selectedChannelList.length; i++) {
      let value: any = {};
      if (this.selectedChannelList[i].toLowerCase() === "email") {
        value.id =
          this.prerewardId > 0
            ? this.prerewardId
            : this.selectedEmailTemplateId;
        value.subject = this.offerEmailSubject;
        data1[this.selectedChannelList[i].toLowerCase()] = value;
        commu = data1;
      } else if (this.selectedChannelList[i].toLowerCase() === "sms") {
        value.id = this.presmsrewardId;
        data1[this.selectedChannelList[i].toLowerCase()] = value;
        commu = data1;
      } else if (this.selectedChannelList[i] === "appOnly") {
        value = {};
        data1[this.selectedChannelList[i]] = value;
        commu = data1;
      } else if (this.selectedChannelList[i].toLowerCase() === "pos") {
        value = {};
        data1[this.selectedChannelList[i].toLowerCase()] = value;
        commu = data1;
      } else if (this.selectedChannelList[i] === "pushNotification") {
        value = {};
        value.title = this.offerPushNotificationSubject;
        value.aliasTitle =
          this.offerPushTitleAlias?.length > 0
            ? this.offerPushTitleAlias
            : null;
        value.body =
          this.offerPushNotificationBody?.length > 0
            ? this.offerPushNotificationBody
            : null;
        data1[this.selectedChannelList[i]] = value;
        commu = data1;
      } else {
        value.id = this.prewhatsappLayoutId;
        data1[this.selectedChannelList[i].toLowerCase()] = value;
        commu = data1;
      }
    }
    return commu;
  }

  convertToOriginalFormat(value) {
    if (value) {
      let result = value
        .map((line) => `• ${line}`) // Add bullet point before each line
        .join("\n"); // Join the lines with newline characters
      //}
      return result;
    }
    return "";
  }

  closeOfferScreen() {
    this.router.navigate(["/app/offer/giftcode"]);
  }
}
